import { Protagonista, ProtagonistaPayload } from 'ducks/protagonistas'

export const parseProtagonistaData = (data: Array<Protagonista>): ProtagonistaPayload | undefined => {
  if (data.length > 0) {
    return { protagonista: data[0] }
  }
  return
}
